import { create } from "zustand";
import { persist } from "zustand/middleware";
export interface ResetPassword {
  email: string;
  setEmail: (email: string) => void;
  otp: string;
  setOtp: (otp: string) => void;
}
export interface PreviewVideo {
  previewVideo: string;
  setPreviewVideo: (previewVideo: string) => void;
}
const useResetPassword = create<ResetPassword>((set: any) => ({
  otp: "",
  email: "",
  setEmail: (email: string) => set({ email }),
  setOtp: (otp: string) => set({ otp }),
}));
const usePreviewVideo = create<PreviewVideo>((set) => ({
  previewVideo: "",
  setPreviewVideo: (previewVideo: string) => set({ previewVideo }),
}));
interface SelectionState {
  selectedRows: (number | string)[];
  allRowIds: (number | string)[];
  clearSelectionTrigger: boolean;
  selectedRowDetails: any[];
  setSelectedRowDetails: (rows: any[]) => void;
  setSelectedRows: (rows: number[]) => void;
  clearSelection: () => void;
  setAllRowIds: (ids: string[]) => void;
  resetClearSelectionTrigger: () => void;
  toggleSelectAll: () => void;
  isAllSelected: boolean; // This will track if all rows are selected
  isFormPending?: boolean;
  setIsFormPending: (value: boolean) => void;
}

const useSelectionStore = create<SelectionState>((set, get) => ({
  selectedRows: [],
  selectedRowDetails: [],
  allRowIds: [],
  isAllSelected: false, // Initial state is false, as nothing is selected initially
  clearSelectionTrigger: false, // New state for triggering row reset
  setSelectedRowDetails: (rows) => set({ selectedRowDetails: rows }),
  setSelectedRows: (rows) => set({ selectedRows: rows }),
  clearSelection: () =>
    set({
      selectedRows: [],
      selectedRowDetails: [],
      clearSelectionTrigger: true, // Trigger selection reset
    }),

  resetClearSelectionTrigger: () => set({ clearSelectionTrigger: false }),
  setAllRowIds: (ids) => set({ allRowIds: ids }),
  toggleSelectAll: () => {
    const { selectedRows, allRowIds } = get();
    const isCurrentlyAllSelected = selectedRows.length === allRowIds.length;

    // If all are selected, deselect all, otherwise select all
    set({
      selectedRows: isCurrentlyAllSelected ? [] : [...allRowIds],
      isAllSelected: !isCurrentlyAllSelected, // Update isAllSelected based on the current state
    });
  },
  isFormPending: false,
  setIsFormPending: (value: boolean) => set(() => ({ isFormPending: value })),
}));
interface UserState {
  user: any;
  isPending: boolean;
  setUser: (user: any) => void;
  setIsPending: (state: boolean) => void;
  clear: () => void;
}
const useUser = create<UserState>()(
  persist(
    (set) => ({
      user: {},
      isPending: true,
      setUser: (user) => set({ user }),
      setIsPending: (state: boolean) => set({ isPending: state }),
      clear: () => set({ user: {} }),
    }),
    {
      name: "user-storage",
    }
  )
);

const usePending = create((set) => ({
  isRetrive: false,
  setIsRetrive: (isRetrive: boolean) => set({ isRetrive }),
}));

interface MetaDataProp {
  search: string;

  setSearch: (e: string) => void;
  clear: () => void;
}

interface MetaDate {
  date: { from: Date | null; to: Date | null };
  setDate: (date: { from: Date | null; to: Date | null }) => void;
  clearDate: () => void;
}

const useMetaStore = create<MetaDataProp & MetaDate>((set) => ({
  search: "",
  date: { from: null, to: null },
  setDate: (date) => set({ date }),
  setSearch: (search: string) => set({ search }),
  clearDate: () => set({ date: { from: null, to: null } }),
  clear: () => set({ search: "", date: { from: null, to: null } }),
}));

const useFilter = create((set) => ({
  filter: {},
  setFilter: (filter: any) => set({ filter }),
}));

export {
  useFilter,
  useMetaStore,
  usePending,
  usePreviewVideo,
  useResetPassword,
  useSelectionStore,
  useUser,
};
